module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('div', {
    staticClass: "aword_alert",
    class: _vm.type || 'select'
  }, [_c('i', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.defContent))]), _vm._v(" "), (_vm.type == 'select') ? _c('ul', [_c('li', {
    staticClass: "danger",
    on: {
      "click": _vm.affirm
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('li', {
    staticClass: "ghost",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]) : (_vm.type == 'error') ? _c('ul', [_c('li', {
    staticClass: "danger",
    on: {
      "click": _vm.affirm
    }
  }, [_vm._v("确认")])]) : _c('ul', [_c('li', {
    staticClass: "danger",
    on: {
      "click": _vm.affirm
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30877366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sdConfirm.vue
// module id = 854
// module chunks = 1